module.exports = __webpack_public_path__ + "static/android-icon-192x192-1144c31849217648c643ac272eb18d4c.png";